import React from "react";
//react-router-dom imports

import { Switch, Route, Redirect, BrowserRouter } from "react-router-dom";
import LoadingScreen from "../../Shared/LoadingScreen";
import lazyRetry from "../../Shared/lazyRetry";
import { useState } from "react";
import { ErrorBoundary } from "@sentry/react";
import Fallback from "../../Shared/Fallback";
import CsnackBar from "../../Shared/CsnackBar";
import UserAuth from "./UserAuth";

const Liveorders = React.lazy(() =>
  lazyRetry(() => import("../../Pages/Liveorders"))
);
const MenuPage = React.lazy(() =>
  lazyRetry(() => import("../../Pages/MenuPage"))
);
const Dashboard = React.lazy(() =>
  lazyRetry(() => import("../../Pages/Dashboard"))
);
const Menu = React.lazy(() => lazyRetry(() => import("../../Pages/Menu")));
// const Reviews = React.lazy(() =>
//  lazyRetry(() => import("../../Pages/Reviews")));
const Invoices = React.lazy(() =>
  lazyRetry(() => import("../../Pages/Invoices"))
);
const Customers = React.lazy(() =>
  lazyRetry(() => import("../../Pages/Customers"))
);
const Theme = React.lazy(() => lazyRetry(() => import("../../Pages/Theme")));
const Settings = React.lazy(() =>
  lazyRetry(() => import("../../Pages/Settings"))
);
const ImageLibrary = React.lazy(() =>
  lazyRetry(() => import("../../Pages/ImageLibrary"))
);
const OrderDetails = React.lazy(() =>
  lazyRetry(() => import("../../Pages/OrderDetails"))
);
const CustomerDetails = React.lazy(() =>
  lazyRetry(() => import("../../Pages/CustomerDetails"))
);
const MenuItems = React.lazy(() =>
  lazyRetry(() => import("../../Pages/MenuItems"))
);
const ResetPassword = React.lazy(() =>
  lazyRetry(() => import("../../Pages/ResetPassword"))
);
const RestLogin = React.lazy(() =>
  lazyRetry(() => import("../../Pages/RestLogin"))
);
const Coupons = React.lazy(() =>
  lazyRetry(() => import("../../Pages/Coupons"))
);
const CouponAnalytics = React.lazy(() =>
  lazyRetry(() => import("../../Pages/CouponAnalytics"))
);
const CouponDashboard = React.lazy(() =>
  lazyRetry(() => import("../../Pages/CouponDashboard"))
);
const BulkExportOrders = React.lazy(() =>
  lazyRetry(() => import("../../Pages/BulkExportOrders"))
);
const Groups = React.lazy(() => lazyRetry(() => import("../../Pages/Groups")));
const Employees = React.lazy(() =>
  lazyRetry(() => import("../../Pages/Employees"))
);
const Version = React.lazy(() =>
  lazyRetry(() => import("../../Pages/VersionManagement"))
);
const Routes = () => {
  const [errorMessage, setErrorMessage] = useState("");
  const onError = (error) => {
    console.log("we got eerror", error);

    setErrorMessage(error.message);
  };

  return (
    <ErrorBoundary
      fallback={<Fallback error={errorMessage} />}
      onError={onError}
    >
      <CsnackBar></CsnackBar>
      <Switch>
        <React.Suspense fallback={<LoadingScreen />}>
          <UserAuth exact path="/" component={Liveorders} />

          <UserAuth
            exact
            path="/order-details/:orderId"
            component={OrderDetails}
          />
          <UserAuth exact path="/dashboard" component={Dashboard} />
          <UserAuth exact path="/menu" component={MenuPage} />
          <UserAuth exact path="/menu/:id" component={Menu} />
          {/* <Route
                        exact
                        path="/reviews"
                        render={(props) => <Reviews  />}
                    /> */}
          <UserAuth exact path="/invoices" component={Invoices} />
          <UserAuth exact path="/customers" component={Customers} />
          <UserAuth
            exact
            path="/customer-details/:customerId"
            component={CustomerDetails}
          />
          <UserAuth exact path="/theme" component={Theme} />
          <UserAuth exact path="/settings" component={Settings} />
          <UserAuth exact path="/coupons" component={Coupons} />
          <UserAuth
            exact
            path="/coupon-analytics"
            component={CouponAnalytics}
          />
          <UserAuth
            exact
            path="/coupon-dashboard"
            component={CouponDashboard}
          />
          <UserAuth exact path="/image-library" component={ImageLibrary} />
          <UserAuth exact path="/menu-items" component={MenuItems} />
          <UserAuth exact path="/reset-password" component={ResetPassword} />
          <UserAuth exact path="/rest-login" component={RestLogin} />
          <UserAuth exact path="/version" component={Version} />
          <UserAuth
            exact
            path="/bulk-export-orders"
            component={BulkExportOrders}
          />
          <UserAuth exact path="/groups" component={Groups} />
          <UserAuth path="/employees" component={Employees}></UserAuth>

          <Redirect from="*" to="/" />
        </React.Suspense>
      </Switch>
    </ErrorBoundary>
  );
};

export default Routes;
